/**
 * minimum 1 number
 * minimum 1 uppercase
 * minimum 1 lowercase
 */
export const PASSWORD = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).*$/;
